"use strict";

var sortBy = require('lodash/sortBy');

var moment = require('moment');

module.exports = function (order, options) {
  var threshold = 500; // default

  var order_date = order.order_date;

  if (!(options.orders && options.orders.freeShippingThreshold)) {
    throw new Error('options.orders.freeShippingThreshold must be defined');
  }

  if (!Array.isArray(options.orders.freeShippingThreshold)) {
    throw new Error('options.orders.freeShippingThreshold must be an array');
  }

  if (!order_date) {
    throw new Error('order.order_date is required');
  }

  var opts = sortBy(options.orders.freeShippingThreshold, ['date']);
  opts.forEach(function (_ref) {
    var date = _ref.date,
        value = _ref.value;

    if (moment(order_date) > moment(date)) {
      threshold = value;
    }
  });
  return order.subtotal >= threshold;
};